import React from 'react'

type LanguageIconProps = {
  className?: string
}

const LanguageIcon = ({ className }: LanguageIconProps) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M12 2.4c-5.293 0-9.6 4.308-9.6 9.6 0 5.293 4.307 9.6 9.6 9.6 5.292 0 9.6-4.308 9.6-9.6S17.292 2.4 12 2.4zM12 4c.314 0 .64.13 1.012.477.373.346.758.904 1.088 1.63.15.331.286.7.41 1.093H9.49c.125-.393.26-.762.41-1.092.331-.727.716-1.285 1.088-1.631C11.36 4.13 11.685 4 12 4zm-3.13.634a8.78 8.78 0 00-.426.813C8.2 5.98 7.994 6.57 7.819 7.2H5.605A7.995 7.995 0 018.87 4.634zm6.26 0A7.995 7.995 0 0118.395 7.2h-2.214c-.176-.63-.383-1.22-.625-1.753a8.781 8.781 0 00-.426-.813zM4.667 8.8h2.797a18.792 18.792 0 00-.245 2.4h-3.18a7.962 7.962 0 01.628-2.4zm4.424 0h5.818c.14.748.235 1.554.272 2.4H8.82a17.09 17.09 0 01.272-2.4zm7.445 0h2.797c.325.747.544 1.553.628 2.4h-3.18a18.784 18.784 0 00-.245-2.4zm-12.497 4h3.18c.032.836.116 1.638.245 2.4H4.667a7.962 7.962 0 01-.628-2.4zm4.78 0h6.362a17.1 17.1 0 01-.272 2.4H9.091a17.09 17.09 0 01-.272-2.4zm7.962 0h3.18a7.96 7.96 0 01-.628 2.4h-2.797c.129-.762.213-1.564.245-2.4zm-11.176 4h2.214c.176.63.382 1.22.625 1.753.13.289.276.556.426.813A7.995 7.995 0 015.605 16.8zm3.884 0h5.022c-.125.393-.26.762-.411 1.092-.33.727-.715 1.285-1.088 1.631-.372.347-.698.477-1.012.477-.315 0-.64-.13-1.013-.477-.372-.346-.757-.904-1.087-1.63-.15-.331-.286-.7-.411-1.093zm6.692 0h2.214a7.995 7.995 0 01-3.265 2.566c.15-.257.295-.524.426-.813.242-.533.45-1.123.625-1.753z"
      ></path>
    </svg>
  )
}

export default LanguageIcon
